const contentswiper = new Swiper('.contents-news-swiper', {
    spaceBetween: 0,
    // 前後の矢印
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    loop:false,
    centeredSlides: true,
    slidesPerGroup: 1,
    slidesPerView: 1,
    grabCursor: true, 
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });